<template>
  <div class='buttons BP journeyP'>

    <!-- <el-skeleton style="width: 240px" :loading="loading" animated></el-skeleton> -->

    <div product>
        <img :src="ProductImage"/>
        <ul v-for="(row,index) in KeyMap" :line='index'>
            <li v-for="(item,i) in row" :key="i"  @click="selectItem" 
             :journey_global="journey_global" 
             :journey="item.journey_trigger =='-'?item.journey_trigger:item.journey_trigger.toFixed(2)" 
             :rt_down="item.journey_RT.down" 
             :rt_up="item.journey_RT.up" 
             :hid="item.hid"  fn="1" isset="1" j="0" r="0" c="0" v-if="item.key_name"  
             :cname="item.name"  
             :name="item.key_name">
             
                <!-- <i>{{item.journey_RT.down}}/{{item.journey_RT.up}}</i> -->
                <!-- <div box>
                        <h2>{{item.journey_trigger}} (mm)</h2>
                        <p>RT/D：{{item.journey_RT.down}}</p>
                        <p>RT/U：{{item.journey_RT.up}}</p>
                </div> -->
            </li>
        </ul>
    </div>

  </div>
</template>
<script>
// import $ from 'jquery' "select": item.select,

export default {
  name: 'journeyButtonC',
  components: 
  {

  },
  data() {

    return {
      HIDDeviceObj:null,
	    KeyMap: [],
      indexes:0,
      curIndex:-1,
      ProductImage:null,
      loading: true,
      journey_global:0
    }
  },
  mounted() 
  { 

  },
  methods: 
  {

    setJourneys(hidObj)
    {
      this.journey_global = hidObj.journey_global.toFixed(2);
      this.KeyMap = hidObj.MatrixList.KeyMap;

    },
    //获取设备图片
    setProductImagePath()
    {

        this.loading = false;
        this.ProductImage = require("../../../../drives/" + this.HIDDeviceObj.curDeviceMode + "/asserts/image/product_k.png");   

        import ("../../../../drives/" + this.HIDDeviceObj.curDeviceMode + "/asserts/css/keyboard.css");
        import ("../../../../drives/" + this.HIDDeviceObj.curDeviceMode + "/asserts/css/buttonBGXY.css");
    },
    //选择
    selectItem(el)
    {  
       el.target.classList.toggle('select');
    },
  }
}

</script>